<template>
  <div class="footer">
    <van-tabbar v-model="active">
      <van-tabbar-item safe-area-inset-bottom v-for="(tab, index) in tabBar" :to="tab.path" :key="index">
        <div class="icon"><span :class="tab.icon"></span></div>
        <div class="font">{{tab.name}}</div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  name:'',
  data(){
    return{
      active: 0,
      tabBar: [
        {
          name: '首页',
          path: '/techHome',
          pathName: 'techHome',
          icon:'el-icon-s-home',//'🏠'
          // icon: {
          //     active: require('@/assets/images/user/insuranceed.png'),
          //     inactive: require('@/assets/images/user/insurance.png'),
          // },
        },
        {
          name: '当前任务',
          path: '/techTask',
          pathName: 'techTask',
          icon:'el-icon-aim',//'📅'
          // icon: {
          //     active: require('@/assets/images/user/ordered.png'),
          //     inactive: require('@/assets/images/user/order.png'),
          // },
        },
        {
            name: '历史任务',
            path: '/techHistory',
            pathName: 'techHistory',
            icon:'el-icon-finished',//'🕒'
            // icon: {
            //     active: require('@/assets/images/user/customered.png'),
            //     inactive: require('@/assets/images/user/customer.png'),
            // },
        },
        {
          name: '我的',
          path: '/techMy',
          pathName: 'techMy',
          icon:'el-icon-user-solid',//'👤'
          // icon: {
          //     active: require('@/assets/images/user/meed.png'),
          //     inactive: require('@/assets/images/user/me.png'),
          // },
        }
      ]
    }
  },
  mounted() {
    // 监听路由变化
    this.$watch('$route', (to, from) => {
      this.tabBar.forEach((tab, i) => {
        if (tab.path === to.path) {
          this.active = i;
          return false;
        }
      });
    });
  },
  methods:{
    setActive(name){
      this.tabBar.forEach((tab, i) => {
        if (tab.pathName === name) {
          this.active = i;
          return false;
        }
      });
    }
  },
  created(){
    const toName = this.$route.name;
    this.setActive(toName);
  }
}
</script>
<style lang="scss">

</style>